module.exports = __webpack_public_path__ + "assets/img/ones.ab1e3538.png";